/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Search_PlaceholderInputs */

const en_nav_search_placeholder = /** @type {(inputs: Nav_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search…`)
};

const ar_nav_search_placeholder = /** @type {(inputs: Nav_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بحث…`)
};

const bn_nav_search_placeholder = /** @type {(inputs: Nav_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সার্চ করুন…`)
};

const de_nav_search_placeholder = /** @type {(inputs: Nav_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suchen …`)
};

const es_nav_search_placeholder = /** @type {(inputs: Nav_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar…`)
};

const fr_nav_search_placeholder = /** @type {(inputs: Nav_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher…`)
};

const pt_nav_search_placeholder = /** @type {(inputs: Nav_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar…`)
};

const zh_nav_search_placeholder = /** @type {(inputs: Nav_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索...`)
};

const tr_nav_search_placeholder = /** @type {(inputs: Nav_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ara…`)
};

const ru_nav_search_placeholder = /** @type {(inputs: Nav_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Искать…`)
};

const pl_nav_search_placeholder = /** @type {(inputs: Nav_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szukaj…`)
};

/**
* | output |
* | --- |
* | "Search…" |
*
* @param {Nav_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const nav_search_placeholder = /** @type {((inputs?: Nav_Search_PlaceholderInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Search_PlaceholderInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_nav_search_placeholder(inputs)
	if (locale === "bn") return bn_nav_search_placeholder(inputs)
	if (locale === "de") return de_nav_search_placeholder(inputs)
	if (locale === "es") return es_nav_search_placeholder(inputs)
	if (locale === "fr") return fr_nav_search_placeholder(inputs)
	if (locale === "pt") return pt_nav_search_placeholder(inputs)
	if (locale === "zh") return zh_nav_search_placeholder(inputs)
	if (locale === "tr") return tr_nav_search_placeholder(inputs)
	if (locale === "ru") return ru_nav_search_placeholder(inputs)
	if (locale === "pl") return pl_nav_search_placeholder(inputs)
	return en_nav_search_placeholder(inputs)
});